/**
 * This function takes an array of elements and returns a new array that yields pairs of consecutive elements.
 * @param array - An array of elements to be paired
 * @returns A new array that contains pairs of consecutive elements from the input array
 * @example
 * const arr = [1, 2, 3, 4];
 * const pairs = pairwise(arr);
 * for (const pair of pairs) {
 *   console.log(pair); // [1, 2], [2, 3], [3, 4]
 * }
 */
export function pairwise<T>(iterable: Iterable<T>): [T, T][] {
  return Array.from(iterable).reduce<[T, T][]>((acc, curr, idx, arr) => {
    if (idx > 0) {
      acc.push([arr[idx - 1], curr]);
    }
    return acc;
  }, []);
}
